import { useNavigate } from "react-router-dom";

const CtaFooter = () => {
    const navigate = useNavigate();
    return (
        <div className='ctaFooter'>
            <div className='ctaFooterContent'>
                Turning visions into reality with precision and care.
            </div>
            <div className='ctaGetInTouch'>
                <button onClick={() => {
                    navigate('/Contacts');
                    setTimeout(() => {
                        const contactForm = document.querySelector('.contactFormContainer');
                        if (contactForm) {
                            contactForm.scrollIntoView({ behavior: "smooth" });
                        } else {
                            window.scrollTo({ top: 0 })
                        }
                    }, 100);
                }}>Get In Touch</button>
            </div>
        </div>
    );
}

export default CtaFooter;
